var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsBarsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 90,
    viewBox: "0 0 86 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.846 0C76.9717 0 74.6416 2.33013 74.6416 5.20449V99C74.6416 100.105 75.537 101 76.6416 101H83.0505C84.1551 101 85.0505 100.105 85.0505 99V5.20449C85.0505 2.33013 82.7204 0 79.846 0ZM55.6104 34.3826C55.6104 31.4468 57.9903 29.0669 60.926 29.0669C63.8618 29.0669 66.2417 31.4468 66.2417 34.3826V98.808C66.2417 99.9125 65.3462 100.808 64.2417 100.808H57.6104C56.5058 100.808 55.6104 99.9125 55.6104 98.808V34.3826ZM18.8096 48.2912C18.8096 45.3555 21.1895 42.9756 24.1252 42.9756C27.061 42.9756 29.4409 45.3555 29.4409 48.2912V98.8077C29.4409 99.9122 28.5455 100.808 27.4409 100.808H20.8096C19.705 100.808 18.8096 99.9122 18.8096 98.8077V48.2912ZM37.6182 55.2022C37.6182 52.4922 39.815 50.2954 42.5249 50.2954C45.2349 50.2954 47.4317 52.4922 47.4317 55.2022V98.807C47.4317 99.9116 46.5363 100.807 45.4317 100.807H39.6182C38.5136 100.807 37.6182 99.9116 37.6182 98.807V55.2022ZM5.31566 59.8124C2.3799 59.8124 0 62.1923 0 65.128V98.8075C0 99.9119 0.895318 100.807 1.99975 100.807H8.63157C9.736 100.807 10.6313 99.9119 10.6313 98.8075V65.128C10.6313 62.1923 8.25142 59.8124 5.31566 59.8124Z",
    fill: "url(#paint0_linear_155_16063)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_16063",
    x1: 42.5253,
    y1: 118.124,
    x2: 42.5253,
    y2: -36.4926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19C48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974704,
    stopColor: "#E7FFF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsBarsGreen);
export default __webpack_public_path__ + "static/media/stats_bars_green.ed9ed38c24565b3c562331831e945771.svg";
export { ForwardRef as ReactComponent };